import {IToJson} from '@toolify/client/src/types/IToJson'

import {mapMessageResponseInstance} from '@toolify/client/src/modules/api/singletons/mapMessageResponseInstance'
import {
  IDirectConversationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDirectConversationResponseInstance'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'

export function mapDirectConversationResponseInstance(conversation: IToJson<IDirectConversationResponseInstance>): IDirectConversationResponseInstance {
  return {
    ...conversation,
    latestMessage: conversation.latestMessage ? mapMessageResponseInstance(conversation.latestMessage) : null,
    cachedFirstEntities: conversation.cachedFirstEntities ? conversation.cachedFirstEntities.map(entity => {
      return mapResponseEntity(entity) // TODO: It should not be "actor"
    }) : null,
    lastActivityAt: conversation.lastActivityAt ? new Date(conversation.lastActivityAt) : null,
    readAt: conversation.readAt ? new Date(conversation.readAt) : null,
    archivedAt: conversation.archivedAt ? new Date(conversation.archivedAt) : null,
  } as IDirectConversationResponseInstance // TODO: TS: Remove "as ..."
}

